import React, { useContext } from 'react';
import { DataContext } from './DataContext';
import { ChakraProvider, SimpleGrid, Box, Heading, Image } from '@chakra-ui/react';
import LoadingComponent from './LoadingComponent.jsx';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

const ServiceList = () => {
  const data = useContext(DataContext);

  if (!data) {
    return <LoadingComponent />;
  }

  const { PodCategory } = data;

  const containerVariants = {
    hidden: { opacity: 0, y: 20 },
    show: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6,
        ease: "easeOut",
        staggerChildren: 0.2,
      },
    },
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 30 },
    show: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.5,
        ease: "easeOut"
      }
    },
  };

  return (
    <ChakraProvider>
      <div className="w-full flex justify-center items-center p-4">
        <motion.div
          className="container mx-auto max-w-7xl w-full"
          variants={containerVariants}
          initial="hidden"
          animate="show"
        >
          <SimpleGrid
            spacing={4}
            columns={{ base: 1, sm: 2, lg: 4 }}
            width="100%"
            px={2}
          >
            {PodCategory.map((service) => (
              <motion.div
                key={service.id}
                variants={itemVariants} // Use variants for initial/animate if preferred over direct props
                className="w-full"
                whileHover={{ scale: 1.05, zIndex: 1 }} // Scale only the item, zIndex brings it forward
                transition={{ duration: 0.3, ease: "easeOut" }} // Smooth transition for hover scale
              >
                <Box
                  as={Link}
                  to={service.Link}
                  position="relative"
                  width="100%"
                  paddingBottom="100%" // Maintain aspect ratio
                  overflow="hidden"
                  borderRadius="xl"
                  display="block" // Ensure Link behaves like a block
                >
                  <Image
                    src={service.serviceImage}
                    alt={service.serviceTitle}
                    objectFit="cover"
                    position="absolute"
                    top="0"
                    left="0"
                    width="100%"
                    height="100%"
                  />
                  <Box
                    position="absolute"
                    top="0"
                    left="0"
                    right="0"
                    // Adjusted gradient for better text visibility
                    background="linear-gradient(to bottom, rgba(0,0,0,0.65) 0%, rgba(0,0,0,0.1) 50%, transparent 100%)"
                    display="flex"
                    alignItems="flex-start" // Align text to the top
                    justifyContent="center"
                    padding="1.5" // Reduced padding further
                    height="auto" // Let height be determined by content and padding
                  >
                    <Heading
                      // Further reduced font size, especially on smaller grids
                      fontSize={{ base: "xs", sm: "sm", md: "sm" }}
                      color="white"
                      textAlign="center"
                      textShadow="1px 1px 2px rgba(0,0,0,0.8)" // Slightly stronger shadow
                      noOfLines={2} // Allow up to 2 lines, truncates overflow
                      lineHeight="1.2" // Adjust line height for tighter spacing
                    >
                      {service.serviceTitle}
                    </Heading>
                  </Box>
                </Box>
              </motion.div>
            ))}
          </SimpleGrid>
        </motion.div>
      </div>
    </ChakraProvider>
  );
};

export default ServiceList;
